import { __exportAll } from "../../../_virtual/_rolldown/runtime.js";
import { createElementBlock, createElementVNode, openBlock } from "vue";
//#region src/components/ScalarIcon/icons/CloseTab.svg?component
var CloseTab_exports = /* @__PURE__ */ __exportAll({
	default: () => CloseTab_default,
	render: () => render$1
});
var _hoisted_1 = {
	xmlns: "http://www.w3.org/2000/svg",
	fill: "none",
	viewBox: "0 0 24 24"
};
function render$1(_ctx, _cache) {
	return openBlock(), createElementBlock("svg", _hoisted_1, [..._cache[0] || (_cache[0] = [createElementVNode("path", {
		stroke: "currentColor",
		"stroke-linecap": "round",
		"stroke-linejoin": "round",
		d: "m9.273 9.273 5.454 5.454m0-5.454-5.454 5.454M5.57 3h12.86A2.57 2.57 0 0 1 21 5.571V18.43A2.57 2.57 0 0 1 18.429 21H5.57A2.57 2.57 0 0 1 3 18.429V5.57A2.57 2.57 0 0 1 5.571 3Z"
	}, null, -1)])]);
}
var CloseTab_default = { render: render$1 };
//#endregion
export { CloseTab_exports, CloseTab_default as default, render$1 as render };

//# sourceMappingURL=CloseTab.svg.virtual.js.map